namespace RioERP.Reports {
    export interface OrderCombinedReportRow {
        Id?: number;
        OrderId?: number;
        OrderDate?: string;
        SourceType?: number;
        SourceOrderNumber?: string;
        FranchiseeName?: string;
        CustomerName?: string;
        CustomerMobile1?: string;
        CustomerEmail1?: string;
        City?: string;
        Address1?: string;
        Address2?: string;
        StateName?: string;
        PinCode?: string;
        ShippingAddress1?: string;
        ShippingAddress2?: string;
        ShippingCity?: string;
        ShippingPincode?: number;
        EOrderStatus?: number;
        PaymentStatus?: number;
        EPaymentType?: number;
        DiscountCoupen?: string;
        TaxableAmount?: number;
        Total?: number;
        DiscountAmount?: number;
        NetAmount?: number;
        TaxableAmountNet?: number;
        CgstRate?: number;
        CgstAmount?: number;
        SgstRate?: number;
        SgstAmount?: number;
        IgstRate?: number;
        IgstAmount?: number;
        TotalTax?: number;
    }

    export namespace OrderCombinedReportRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SourceOrderNumber';
        export const localTextPrefix = 'Reports.OrderCombinedReport';
        export const deletePermission = 'Reports:ReportsManagement:Modify';
        export const insertPermission = 'Reports:ReportsManagement:Modify';
        export const readPermission = 'Reports:ReportsManagement:View';
        export const updatePermission = 'Reports:ReportsManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            OrderId = "OrderId",
            OrderDate = "OrderDate",
            SourceType = "SourceType",
            SourceOrderNumber = "SourceOrderNumber",
            FranchiseeName = "FranchiseeName",
            CustomerName = "CustomerName",
            CustomerMobile1 = "CustomerMobile1",
            CustomerEmail1 = "CustomerEmail1",
            City = "City",
            Address1 = "Address1",
            Address2 = "Address2",
            StateName = "StateName",
            PinCode = "PinCode",
            ShippingAddress1 = "ShippingAddress1",
            ShippingAddress2 = "ShippingAddress2",
            ShippingCity = "ShippingCity",
            ShippingPincode = "ShippingPincode",
            EOrderStatus = "EOrderStatus",
            PaymentStatus = "PaymentStatus",
            EPaymentType = "EPaymentType",
            DiscountCoupen = "DiscountCoupen",
            TaxableAmount = "TaxableAmount",
            Total = "Total",
            DiscountAmount = "DiscountAmount",
            NetAmount = "NetAmount",
            TaxableAmountNet = "TaxableAmountNet",
            CgstRate = "CgstRate",
            CgstAmount = "CgstAmount",
            SgstRate = "SgstRate",
            SgstAmount = "SgstAmount",
            IgstRate = "IgstRate",
            IgstAmount = "IgstAmount",
            TotalTax = "TotalTax"
        }
    }
}
